import { Component, ViewChild, Input, Output, OnChanges, OnInit, SimpleChanges, EventEmitter } from '@angular/core';
import GatewayDto  from '../../dto/gateway-dto';
import { GatewayService }  from '../../gateway.service';
import { Observable }  from 'rxjs/Observable';
import { Subscription } from 'rxjs/Rx';

@Component({
  selector: 'gateway-deployment-configuration',
  template: require('./gateway-deployment-configuration.html')
})

export default class GatewayDeploymentConfigurations implements OnChanges {
    @Input('gateway') gateway: GatewayDto;
    @Input('isEditMode') isEditMode: boolean;
    @Input('vcContainers') vcContainers: any;

    @Output('onNoDeploymentContainerFound') noDeploymentContainerFound = new EventEmitter();

    public confirmPassword: string;
    public deployedEdgeType: string = 'local';
    public showScopes: boolean = false;
    public deploymentContainers: any;
    public showDeploymentContainer: boolean = false;
    public deploymentContainerLoaded: boolean = false;
    public haStatus: string;
    public subscribeHandler: Subscription;
    public applianceSizes = [
        { value: 'compact', display: 'Compact (1 vCPU, 512 MB MEM)' },
        { value: 'large', display: 'Large (2 vCPU, 1024 MB MEM)' },
        { value: 'xlarge', display: 'X-Large (6 vCPU, 8192 MB MEM)' },
        { value: 'quadlarge', display: 'Quad-Large (4 vCPU, 2048 MB MEM)' }
    ];
    public edgeTypes = [
        { value: 'local', display: 'Access Router' },
        { value: 'perimeter', display: 'Aggregation Router' }
    ];

    private isError: boolean = false;
    private errorMessage: string;


    constructor(private gatewayService: GatewayService) {
    }

    applianceSizeChanged(size: string) {
        this.gateway.edgeVmSize = size;
    }

    ngOnChanges(changes: SimpleChanges) {
        this.deployedEdgeType = (this.gateway.scopeId === ('' || undefined) ? 'perimeter' : 'local');
        if (this.deployedEdgeType === 'local') {
            this.setDefaultVcContainer();
            this.showScopes = true;
            this.showDeploymentContainer = true;
            if (!this.deploymentContainerLoaded && !this.isEditMode) {
                this.getLocalDeploymentContainers();
            }
        } else {
            this.showDeploymentContainer = true;
            this.gateway.scopeId = undefined;
        }
        this.updateHAStatus();
    }

    edgeTypeChanged(edgeType): void {
        this.deployedEdgeType = edgeType;
        this.showDeploymentContainer = true;
        if (this.deployedEdgeType === 'perimeter') {
            this.showScopes = false;
            this.deploymentContainerLoaded = false;
            this.gateway.scopeId = undefined;
            this.getGlobalDeploymentContainers();
        } else {
            this.setDefaultVcContainer();
            this.getLocalDeploymentContainers();
            this.showScopes = true;
        }
    }

    setDefaultVcContainer() {
        if (this.gateway.scopeId === undefined) {
            this.gateway.scopeId = this.vcContainers[0].scopeId;
        }
    }

    getGlobalDeploymentContainers() {
        this.subscribeHandler = this.gatewayService.getGlobalDeploymentContainers()
            .subscribe(
            containers => {
                this.deploymentContainers = containers;
                if(this.deploymentContainers.length === 0){
                    // There are no deployment containers created
                    // show error to the user and disable next button
                    this.onNoDeploymentContainer();
                } else {
                    // assign the deployment container only if gateway doesn't already have the same deployment container
                    if (this.gateway.deploymentContainerId === undefined) {
                        this.gateway.deploymentContainerId = this.deploymentContainers[0].id;
                    } else {
                        if(this.gateway.deploymentContainerId !== this.deploymentContainers[0].id){
                            this.gateway.deploymentContainerId = this.deploymentContainers[0].id;
                        }
                    }
                }
                this.deploymentContainerLoaded = true;
            },
            error => this.logError(error, 'could not get global deployment containers'),
            () => this.logOperationCompleted('got global deployment containers')
        );
    }

    getLocalDeploymentContainers() {
        this.subscribeHandler = this.gatewayService.getLocalDeploymentCotainers(this.gateway.scopeId)
            .subscribe(
            containers => {
                this.deploymentContainers = containers;
                if(this.deploymentContainers.length === 0){
                    // There are no deployment containers created
                    // show error to the user and disable next button
                    this.onNoDeploymentContainer();
                } else {
                    // assign the deployment container only if gateway doesn't already have the same deployment container
                    if (this.gateway.deploymentContainerId === undefined) {
                        this.gateway.deploymentContainerId = this.deploymentContainers[0].id;
                    } else {
                        if(this.gateway.deploymentContainerId !== this.deploymentContainers[0].id){
                            this.gateway.deploymentContainerId = this.deploymentContainers[0].id;
                        }
                    }
                }
                this.deploymentContainerLoaded = true;
            },
            error => this.logError(error, 'could not get local deployment containers for scope '+ this.gateway.scopeId),
            () => this.logOperationCompleted('got local deployment containers')
        );
    }


    onEdgeScopeChanged(event) {
        this.gateway.scopeId = event.target.value;
        this.deploymentContainerLoaded = false;
        this.getLocalDeploymentContainers();
    }

     logError(error, origin: String = ''): void {
        console.error('Error: ', error, (origin !== '') ? ' Error from ' + origin : '');
    }

    logOperationCompleted(msg: string): void{
        console.log('Operation Completed: ', msg);
    }

    changeHighAvailability(event) {
        this.gateway.haSettings.enabled = !this.gateway.haSettings.enabled;
        this.updateHAStatus();
    }

    updateHAStatus() {
        this.haStatus = this.gateway.haSettings.enabled ? 'Activated' : 'Deactivated';
    }

    onNoDeploymentContainer(){
        this.isError = true;
        this.errorMessage = 'There are no deployment containers created.'+
        ' Please contact the system administrator to create at least one deployment container.';
        this.noDeploymentContainerFound.emit();
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/networking/networking-vc/gateways/dialogs/wizard-steps/gateway-deployment-configuration.component.ts